export const GET_EXCESS_BAGGAGES = 'GET_EXCESS_BAGGAGES';
export const CLEAR_EXCESS_BAGGAGES = 'CLEAR_EXCESS_BAGGAGES';
export const FLAG_GETTING_EXCESS_BAGGAGES = 'FLAG_GETTING_EXCESS_BAGGAGES';
